// Kiosk Ürünleri sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.kioskProducts';

export const kioskProductsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Kiosk Ürünleri sayfası nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu sayfa, stok kartında "Kiosk\'ta açık" işaretlenmiş tüm ürünleri tek listede gösterir; buradan bir ürünü kiosk satışına kapatabilirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtre'),
    stats: t(`${G}.regions.stats`, 'Özet'),
    table: t(`${G}.regions.table`, 'Ürün listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu sayfa ne gösterir?'),
      text: t(`${G}.s1.text`, 'Kioskta satışa açık ürünlerin listesidir. Ürünü kiosklarda açmak bu sayfadan değil, Stok sayfasından yapılır. Sol üstteki geri oku Kiosk Menü Yönetimi\'ne döner.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Arayın ve filtreleyin'),
      text: t(`${G}.s2.text`, 'Arama kutusu ürün adı, stok kodu, barkod, kategori ve markada arar. Liste açılışta yalnız aktif ürünleri gösterir; "Sadece Aktif" düğmesine basınca pasif ürünler de listelenir ("Tümünü Göster"), tekrar basınca yalnız aktiflere döner.'),
    },
    {
      region: 'stats',
      title: t(`${G}.s3.title`, '3. Özet sayıları'),
      text: t(`${G}.s3.text`, 'Toplam Ürün kioskta açık tüm ürünleri, Aktif Ürün bunların aktif olanlarını, Filtrelenen ise arama ve filtreden sonra listede kalanları sayar.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Ürünü kiosktan kapatın'),
      text: t(`${G}.s4.text`, 'Satırdaki ⋮ → "Kiosk\'tan Kapat" onaydan sonra ürünün kioskta satışını kapatır ve ürün bu listeden çıkar. Ürün silinmez, stok kartı aynen kalır; Stok sayfasından tekrar açılabilir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Satırda stok kodu, barkod, kategori, marka, satış fiyatı ve durum görünür.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s5.title`, '5. Sayfalama'),
      text: t(`${G}.s5.text`, 'Alttan sayfa başına 10, 25, 50 veya 100 satır seçebilirsiniz.'),
    },
  ],
});
